import { jsx, Fragment } from "react/jsx-runtime";
import { renderMessageContentWithCarousels } from "../../utils/messageRenderer.js";
function resolveNumberedRefs(text, sourcesMap) {
  return text.replace(/\[(\d+)\]/g, (_m, num) => {
    const source = sourcesMap.get(num);
    if (!source) return _m;
    const label = source.title || source.url;
    return `[${label}](${source.url})`;
  });
}
function TextPart({
  text,
  productMetadataMap,
  onProductClick,
  sourcesMap
}) {
  if (!text.trim()) return null;
  const processed = (sourcesMap == null ? void 0 : sourcesMap.size) ? resolveNumberedRefs(text, sourcesMap) : text;
  const renderedContent = renderMessageContentWithCarousels(
    processed,
    productMetadataMap || /* @__PURE__ */ new Map(),
    /* @__PURE__ */ new Map(),
    false,
    false
  );
  if (renderedContent.length > 0) {
    return /* @__PURE__ */ jsx(Fragment, { children: renderedContent });
  }
  return /* @__PURE__ */ jsx("div", { className: "concierge-text-part", children: text.split("\n\n").map((paragraph, i) => /* @__PURE__ */ jsx("p", { children: paragraph }, i)) });
}
export {
  TextPart
};
//# sourceMappingURL=TextPart.js.map
